export default __webpack_public_path__ + "static/media/bainbridge_hero_600.92d4efd7.jpg";